import {
  call, put, fork, takeLatest,
} from 'redux-saga/effects'
import * as SchoolApi from '../../api/school'
import {
  FETCH_PAYMENT_SERVICE_CHARGES_REQUEST,
  FETCH_PAYMENT_SERVICE_CHARGES_SUCCESS,
  FETCH_PAYMENT_SERVICE_CHARGES_FAILURE,
} from '../../actions/school'
import { addError } from '../../actions/notifications'

export function* fetchPaymentServiceCharge() {
  try {
    const res = yield call(SchoolApi.fetchPaymentServiceCharges)
    yield put({
      type: FETCH_PAYMENT_SERVICE_CHARGES_SUCCESS,
      serviceCharges: res.service_charges,
    })
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: FETCH_PAYMENT_SERVICE_CHARGES_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchPaymentServiceCharges() {
  yield takeLatest(FETCH_PAYMENT_SERVICE_CHARGES_REQUEST, fetchPaymentServiceCharge)
}

export default [fork(watchFetchPaymentServiceCharges)]
